import {
  Button,
  Grid,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
  useMediaQuery,
  Backdrop,
  CircularProgress
} from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomTextField from "../CustomComponents/CustomTextField";
import { Box } from "@mui/system";
import axios from "axios";
import { BranchAction } from "../Store/Branch";
import { useDispatch, useSelector } from "react-redux";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomDateField from "../CustomComponents/CustomDateField";
import dayjs from "dayjs";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const ChequeAndMandateBulkReturn = () => {
  //Dispatch
  const dispatch = useDispatch();
  // Loading Branches
  const [branchArray, setBranchArray] = useState([]);
  const [branchValue, setBranchValue] = useState("");
  const [branchTouch, setBranchTouch] = useState(false);
  const [branchValid, setBranchValid] = useState(false);
  const [branchHasError, setBranchHasError] = useState(false);

  const [voucherDate, setVoucherDate] = useState("");
  const [voucherDateTouch, setVoucherDateTouch] = useState(false);
  const [voucherDateValid, setVoucherDateValid] = useState(false);
  const [voucherDateHasError, setVoucherDateHasError] = useState(false);
  const [voucherDateValidDateError, setVoucherDateValidDateError] =
    useState(false);

  const [instrumentTypeArray, setInstrumentTypeArray] = useState([
    "CHEQUE",
    "MANDATE",
  ]);
  const [instrumentType, setInstrumentValue] = useState("");
  const [instrumentTouch, setInstrumentTouch] = useState(false);
  const [instrumentValid, setInstrumentValid] = useState(false);
  const [instrumentHasError, setInstrumentHasError] = useState(false);

  const [uploadBtnDisable, setUploadBtnDisable] = useState(false);

  const [recrdDwnldDisable, setRecrdDwnldDisable] = useState(false);

  //Success Dialog Message Handler
  const [sucessDialogOpen, setSuccessDialogOpen] = useState(false);
  //Handle Sucess Dialog Message
  const [successDialogMessage, setSuccessDialogMessage] = useState("");
  const handlerSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
  };

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);
  const userName = useSelector((state) => state.branch.userName);

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  //shortcut key
  const downloadRef = useRef(null);
  const uploadRef = useRef(null);
  const recordDownloadRef = useRef(null);
  const okRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "bulkReturn",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      downloadRef: downloadRef,
      uploadRef: uploadRef,
      recordDownloadRef: recordDownloadRef,
      okRef: okRef,
    };
    let date = new Date();
    if (event.ctrlKey) {
      if (charCode === "i") {
        setVoucherDate(date);
      } else if (charCode === "p" && date.getDate() !== 1) {
        date.setDate(date.getDate() - 1);
        setVoucherDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "bulkReturn",
          })
        );
      }
    }
  };

  useEffect(() => {
    const branchValues = GetBranchDetails();
    setBranchArray(branchValues);
    if (branchValues.length === 1) {
      const newValue = branchValues[0];
      setBranchValue(newValue);
      setBranchTouch(newValue ? false : true);
      setBranchValid(
        newValue !== undefined && newValue !== "" && newValue !== null
      );
      setBranchHasError(
        (newValue ? false : true) &&
          !(newValue !== undefined && newValue !== "" && newValue !== null)
      );
      dispatch(BranchAction.updateInitialLoad(false));
      if (newValue) {
        dispatch(BranchAction.updateHeaderBranchDetails(newValue.label));
      }
    }
    // load the current date for the voucher date as default value.
    const currentDate = new Date();
    setVoucherDate(currentDate);
    setVoucherDateTouch(currentDate ? false : true);
    setVoucherDateValid(
      currentDate !== undefined && currentDate !== "" && currentDate !== null
    );
    const voucherDateErrorFlag =
      (currentDate ? false : true) &&
      !(
        currentDate !== undefined &&
        currentDate !== "" &&
        currentDate !== null
      );
    setVoucherDateHasError(voucherDateErrorFlag);
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const handleDownload = () => {
    if (instrumentValid) {
      try {
        setLoading(true)
        setLoadingMsg("Bulk return Sample Import File Downloading Please wait")
        const formData = new FormData();
        formData.append("bulkReturnMode", instrumentType);
        axios
          .post("/chequeAndMandateBulkReturn/downloadExcel", formData, {
            method: "POST",
            responseType: "blob",
          })
          .then((response) => {
            const fileName = instrumentType === "CHEQUE" ? "Cheque" : "Mandate";
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${fileName}Return_upload.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoading(false)
            setMessage("Bulk return Sample Import File Downloaded Success.");
            setAlertType("success");
            openAlertHandler();
          });
      } catch (error) {
        setLoading(false)
        setMessage("Bulk return Sample Import File Downloaded Failed.");
        setAlertType("error");
        openAlertHandler();
        throw Error(error);
      }
    } else {
      setInstrumentTouch(true);
      setInstrumentHasError(true);
      setInstrumentValid(false);
    }
  };

  //Record Download
  const handleRecrdDownload = () => {
    if (instrumentValid) {
      try {
        setLoading(true)
        setLoadingMsg("Bulk return Records File Downloading Please wait")
        const formData = new FormData();
        formData.append("voucherDate", voucherDate);
        formData.append("bulkReturnMode", instrumentType);
        axios
          .post("/chequeAndMandateBulkReturn/downloadReceiptData", formData, {
            method: "POST",
            responseType: "blob",
          })
          .then((response) => {
            const fileName = instrumentType === "CHEQUE" ? "Cheque_Receipt_" : "Mandate_";
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${fileName}Records.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoading(false)
            setMessage("Bulk return Records File Downloaded Success.");
            setAlertType("success");
            openAlertHandler();
          });
      } catch (error) {
        setLoading(false)
        setMessage("Bulk return Records File Downloaded Failed.");
        setAlertType("error");
        openAlertHandler();
        throw Error(error);
      }
    } else {
      setInstrumentTouch(true);
      setInstrumentHasError(true);
      setInstrumentValid(false);
    }
  };

  const validateBranch = () => {
    if (
      //feature-767359
      //!branchValid ||
      !instrumentValid ||
      !voucherDateValid ||
      voucherDateValidDateError
    ) {
      //feature-767359
      // if (!branchValid) {
      //   setBranchTouch(true);
      //   setBranchHasError(true);
      //   setBranchValid(false);
      // }

      if (!voucherDateValid) {
        setVoucherDateTouch(true);
        setVoucherDateHasError(true);
        setVoucherDateValid(false);
      }

      if (!instrumentValid) {
        setInstrumentTouch(true);
        setInstrumentHasError(true);
        setInstrumentValid(false);
      }

      // now reset the dialog close.
      let element = document.getElementById("fileUploadInput");
      element.disabled = true;
      setTimeout(function () {
        element.disabled = false;
      }, 1);
    } else {
      setBranchValid(
        branchValue !== undefined && branchValue !== "" && branchValue !== null
      );
      setBranchTouch(false);
      setBranchHasError(branchTouch && !branchValid);

      setVoucherDateValid(
        voucherDate !== undefined && voucherDate !== "" && voucherDate !== null
      );
      setVoucherDateTouch(false);
      setVoucherDateHasError(voucherDateTouch && !voucherDateValid);

      setInstrumentValid(
        instrumentType !== undefined &&
          instrumentType !== "" &&
          instrumentType !== null
      );
      setInstrumentTouch(false);
      setInstrumentHasError(branchTouch && !branchValid);
    }
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const handleFileUpload = async (event) => {
    setUploadBtnDisable(true);
    const file = event.target.files[0];
    try {
      setLoading(true)
      setLoadingMsg("Bulk Return Processing Please wait")
      //feature-767359
      //const branchCodeValue = getSelectedBranchCode(branchValue.label);
      event.preventDefault();
      const formData = new FormData();
      formData.append("file", file);
      //feature-767359
      //formData.append("branch", branchValue.label);
      //formData.append("branchCode", branchCodeValue);
      formData.append("voucherDate", voucherDate);
      formData.append("bulkReturnMode", instrumentType);
      formData.append("userName", userName);
      // now reset the file.
      let element = document.getElementById("fileUploadInput");
      element.value = null;
      const response = await axios.post(
        "/chequeAndMandateBulkReturn/uploadBulkReturnExcel",
        formData,
        {
          method: "POST",
          responseType: "blob",
        }
      );
      if (response.status === 200) {
        setLoading(false)
        setSuccessDialogOpen(true);
        setSuccessDialogMessage("Bulk Return Process Completed Successfully.");
        setMessage("Bulk Return Process Completed Successfully.");
        setAlertType("success");
        //openAlertHandler();
        setUploadBtnDisable(false);
      }
      if (response.status === 206) {
        setLoading(false)
        setMessage("Error Data Exists in Imported File");
        setAlertType("error");
        openAlertHandler();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        let fileName = null;
        if (instrumentType === "CHEQUE") {
          if (
            response.headers["filename"] !== null &&
            response.headers["filename"] !== undefined
          ) {
            fileName =
              response.headers["filename"] + `__` + new Date() + `.xlsx`;
          } else {
            fileName = `ChequeReturn_ErrorData__` + new Date() + `.xlsx`;
          }
        } else {
          fileName = `MandateReturn_ErrorData__` + new Date() + `.xlsx`;
        }
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setUploadBtnDisable(false);
      }
    } catch (error) {
      setLoading(false)
      setUploadBtnDisable(false);
      if (error.response.status === 400 || error.response.status === 500) {
        //feature-767359
        //const branchCodeValue = getSelectedBranchCode(branchValue.label);
        try{
        setLoading(true)
        setLoadingMsg("Error Check Processing Please wait")
        const formData = new FormData();
        formData.append("file", file);
        //feature-767359
        //formData.append("branch", branchValue.label);
        //formData.append("branchCode", branchCodeValue);
        formData.append("voucherDate", voucherDate);
        formData.append("bulkReturnMode", instrumentType);
        const response = await axios.post(
          "/chequeAndMandateBulkReturn/uploadBulkReturnExcelErrorCheck",
          formData
        );
        setLoading(false)
        if (response.status === 206) {
          setMessage(response.data);
          setAlertType("error");
        }
        if (response.status === 400 || response.status === 500) {
          setMessage("Server Error in processing the uploaded file");
          setAlertType("error");
        }
        openAlertHandler();
      }catch(error){
        setLoading(false)
        throw new Error(error);
      }
      }
    }
  };

  return (
    <React.Fragment>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord"
          title="Bulk Return Process"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <Grid container spacing={1}>
            {/* feature-767359 */}
            {/* <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Branch"
                label="Branch"
                required={true}
                autoCompleteValues={branchArray}
                value={branchValue}
                onChange={(event, newValue) => {
                  setBranchValue(newValue);
                  setBranchTouch(newValue ? false : true);
                  setBranchValid(
                    newValue !== undefined &&
                      newValue !== "" &&
                      newValue !== null
                  );
                  setBranchHasError(
                    (newValue ? false : true) &&
                      !(
                        newValue !== undefined &&
                        newValue !== "" &&
                        newValue !== null
                      )
                  );
                  dispatch(BranchAction.updateInitialLoad(false));
                  // on Branch change remove the set voucher date.
                  const dateValue = null;
                  setVoucherDate(dateValue);
                  setVoucherDateTouch(dateValue ? false : true);
                  setVoucherDateValid(
                    dateValue !== undefined &&
                      dateValue !== "" &&
                      dateValue !== null
                  );
                  const voucherDateErrorFlag =
                    (dateValue ? false : true) &&
                    !(
                      dateValue !== undefined &&
                      dateValue !== "" &&
                      dateValue !== null
                    );
                  setVoucherDateHasError(voucherDateErrorFlag);

                  if (newValue) {
                    dispatch(
                      BranchAction.updateHeaderBranchDetails(newValue.label)
                    );
                  }
                }}
              />
              {branchHasError && <p className="error">Please Select Branch</p>}
            </Grid> */}
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <CustomDateField
                label="Voucher date"
                variant="standard"
                required={true}
                value={voucherDate}
                minDate={
                  new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                }
                maxDate={new Date()}
                onChange={(newValue) => {
                  setVoucherDate(
                    new Date(dayjs(newValue).format("MM/DD/YYYY"))
                  );
                  setVoucherDateTouch(newValue ? false : true);
                  setVoucherDateValid(
                    newValue !== undefined &&
                      newValue !== "" &&
                      newValue !== null
                  );
                  const voucherDateErrorFlag =
                    (newValue ? false : true) &&
                    !(
                      newValue !== undefined &&
                      newValue !== "" &&
                      newValue !== null
                    );
                  setVoucherDateHasError(voucherDateErrorFlag);
                  let validDateErrorFlag = false;
                  if (
                    newValue !== null &&
                    newValue !== undefined &&
                    newValue !== ""
                  ) {
                    validDateErrorFlag =
                      new Date(newValue).toDateString() !== "Invalid Date" &&
                      new Date(newValue).toLocaleDateString().slice(-4) >=
                        String(
                          new Date(
                            new Date(
                              new Date().getFullYear(),
                              new Date().getMonth(),
                              1
                            )
                          ).getFullYear()
                        ) &&
                      new Date(newValue) >=
                        new Date(
                          dayjs(
                            new Date(
                              new Date().getFullYear(),
                              new Date().getMonth(),
                              1
                            )
                          ).format("MM/DD/YYYY")
                        ) &&
                      new Date(newValue).toLocaleDateString().slice(-4) <=
                        String(new Date().getFullYear()) &&
                      new Date(newValue) <=
                        new Date(dayjs(new Date()).format("MM/DD/YYYY"))
                        ? false
                        : true;
                    setVoucherDateValidDateError(validDateErrorFlag);
                  } else {
                    setVoucherDateValidDateError(false);
                  }
                  setUploadBtnDisable(
                    voucherDateErrorFlag || validDateErrorFlag
                  );
                  setRecrdDwnldDisable(voucherDateErrorFlag || validDateErrorFlag)
                }}
              />
              {voucherDateHasError && (
                <p className="error">Please Set Voucher Date</p>
              )}
              {voucherDateValidDateError && (
                <p className="error">Please Enter Valid Date</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Instrument Type"
                label="Instrument Type"
                required={true}
                autoCompleteValues={instrumentTypeArray}
                value={instrumentType}
                onChange={(event, newValue) => {
                  setInstrumentValue(newValue);
                  setInstrumentTouch(newValue ? false : true);
                  setInstrumentValid(
                    newValue !== undefined &&
                      newValue !== "" &&
                      newValue !== null
                  );
                  setInstrumentHasError(
                    (newValue ? false : true) &&
                      !(
                        newValue !== undefined &&
                        newValue !== "" &&
                        newValue !== null
                      )
                  );
                }}
              />
              {instrumentHasError && (
                <p className="error">Please Select Instrument Type</p>
              )}
            </Grid>
          </Grid>
          <Box
            sx={{
              marginTop: "12px",
              marginBottom: "8px",
              display: "flex",
              gap: "2rem",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+J" placement="top">
              <Button
                variant="contained"
                component="label"
                onClick={handleDownload}
                ref={downloadRef}
              >
                Download
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+U" placement="top">
              <Button
                variant="contained"
                component="label"
                disabled={uploadBtnDisable}
                onClick={validateBranch}
                ref={uploadRef}
              >
                Upload
                <input
                  hidden
                  id="fileUploadInput"
                  accept=".xlsx"
                  type="file"
                  onChange={handleFileUpload}
                />
              </Button>
            </Tooltip>
            <Tooltip title="" placement="top">
              <Button
                variant="contained"
                component="label"
                onClick={handleRecrdDownload}
                disabled={recrdDwnldDisable}
                ref={recordDownloadRef}
              >
                Records Download
              </Button>
            </Tooltip>
          </Box>
          <Dialog
            open={sucessDialogOpen}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{"Success"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {successDialogMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Ctrl+K" placement="top">
                <Button onClick={handlerSuccessDialogClose} ref={okRef}>
                  OK
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
          <Snackbar
            open={alert}
            autoHideDuration={3000}
            anchorOrigin={{ vertical, horizontal }}
            onClose={closeAlertHandler}
          >
            <Alert
              onClose={closeAlertHandler}
              severity={alertType}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
        </AccordianContainer>
      </Box>
      <StlapFooter />
    </React.Fragment>
  );
};

export default ChequeAndMandateBulkReturn;
